var tvPCPublic = null, tvPCPrivate = null, dlgProcore = null;

function ProcoreCompanyChanged(sender) {
	dlgProcore.dialog('close');
	dlgProcore = null;
	ShowBusy('Connecting to Procore...');
	new PJQ.ajax.Request({
		endpoint: '/procore/settings/' + parseInt(jQuery(sender).val()),
		isPascal: true
	}).get().done(_.bind(function (response) {
		GetProcoreSettingsC(response);
	}, this)).fail(_.bind(function (xhr, err, result) {

	}, this));
}

function Procore(companyId) {
	if (project.ExternalProjectId.startsWith('PROCORE')) {
		var temp = project.ExternalProjectId.substring(8);
		var url = settings.ProcoreURL + "/" + temp + "/project/home";
		showInfoDialogPWall('Procore', 'This project has already been created in Procore.<br /><br /><a href="' + url + '" target="_blank">Click here to open this project in Procore.', 'ui-icon-info');

		return;
	}

	ShowBusy('Connecting to Procore...');

	if (project.MasterUserId == 23) {
		jQuery('#procore-est-start').val(jQuery('#project-custom-34').val());
		jQuery('#procore-est-complete').val(jQuery('#project-custom-35').val());
		jQuery('#procore-square-feet').val(jQuery('#project-custom-16').val());
	}

	jQuery('#procore-project-name').val(jQuery('#project-name').val());

	if (null != tvPCPublic)
		tvPCPublic.destructor();
	tvPCPublic = new dhtmlXTreeObject("procore-public-tree", "95%", "100%", 0);
	tvPCPublic.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
	tvPCPublic.enableMultiLineItems("200px");
	tvPCPublic.enableTreeLines(false);
	//tvPCPublic.enableContextMenu(cmPublic);
	tvPCPublic.enableItemEditor(false);
	tvPCPublic.setDataMode('json');
	tvPCPublic.enableCheckBoxes(true);
	tvPCPublic.enableSmartCheckboxes(true);
	tvPCPublic.enableThreeStateCheckboxes(true);
	tvPCPublic.loadXML("/DesktopModules/PJQProjectWallAdmin/GetSharedFolders.aspx?sessionid=" + pjqSessionId + "&id=0&fc=1&x=" + (new Date).getTime(), null);

	if (null != tvPCPrivate)
		tvPCPrivate.destructor();
	tvPCPrivate = new dhtmlXTreeObject("procore-private-tree", "95%", "100%", 0);
	tvPCPrivate.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
	tvPCPrivate.enableMultiLineItems("200px");
	tvPCPrivate.enableTreeLines(false);
	tvPCPrivate.enableContextMenu(cmPrivate);
	tvPCPrivate.enableItemEditor(false);
	tvPCPrivate.setDataMode('json');
	tvPCPrivate.enableCheckBoxes(true);
	tvPCPrivate.enableSmartCheckboxes(true);
	tvPCPrivate.enableThreeStateCheckboxes(true);
	tvPCPrivate.loadXML("/DesktopModules/PJQProjectWallAdmin/GetPrivateFolders.aspx?sessionid=" + pjqSessionId + "&id=0&fc=1&x=" + (new Date).getTime() + '&projectid=' + PJQ.app.session.project.id.toString(), null);

	jQuery('#procore-company').val('');

	new PJQ.ajax.Request({
		endpoint: '/procore/settings/' + (companyId > 0 ? companyId : -1),
		isPascal: true
	}).get().done(_.bind(function (response) {
		GetProcoreSettingsC(response);
	}, this)).fail(_.bind(function (xhr, err, result) {

	}, this));
}

function GetProcoreSettingsC(response) {
	HideBusy();
	
	let procoreSettings = response; // $.parseJSON(response);

	var tempVal = jQuery('#procore-company').val();
	jQuery('#procore-company option').remove();
	var i = 0;
	for (i = 0; i < procoreSettings.Companies.length; i++) {
		jQuery('#procore-company').append("<option value='" + procoreSettings.Companies[i].id + "'>" + procoreSettings.Companies[i].name + "</option>");
	}
	if (tempVal)
		jQuery('#procore-company').val(tempVal);

	jQuery('#procore-company').prop('disabled', (procoreSettings.Companies.length == 1));

	jQuery('#procore-company-office option').remove();

	if (procoreSettings.CompanyOffices.length > 0)
		jQuery('#procore-company-office').append("<option value=''>Select...</option>");

	for (i = 0; i < procoreSettings.CompanyOffices.length; i++) {
		jQuery('#procore-company-office').append("<option value='" + procoreSettings.CompanyOffices[i].id + "'>" + procoreSettings.CompanyOffices[i].name + "</option>");
	}

	if (procoreSettings.CompanyOffices.length == 0)
		jQuery('#procore-company-office').append("<option value=''>N/A</option>");

	jQuery('#procore-company-office').prop('disabled', (procoreSettings.CompanyOffices.length < 1));

	jQuery('#procore-project-program option').remove();
	if (procoreSettings.Programs.length > 0)
		jQuery('#procore-project-program').append("<option value=''>Select...</option>");
	for (i = 0; i < procoreSettings.Programs.length; i++) {
		jQuery('#procore-project-program').append("<option value='" + procoreSettings.Programs[i].id + "'>" + procoreSettings.Programs[i].name + "</option>");
	}


	if (procoreSettings.Programs.length == 0)
		jQuery('#procore-project-program').append("<option value=''>N/A</option>");

	jQuery('#procore-project-program').prop('disabled', (procoreSettings.Programs.length < 1));

	jQuery('#procore-project-template option').remove();
	if (procoreSettings.ProjectTemplates.length > 0)
		jQuery('#procore-project-template').append("<option value=''>Select...</option>");
	for (i = 0; i < procoreSettings.ProjectTemplates.length; i++) {
		jQuery('#procore-project-template').append("<option value='" + procoreSettings.ProjectTemplates[i].id + "'>" + procoreSettings.ProjectTemplates[i].name + "</option>");
	}

	if (procoreSettings.ProjectTemplates.length == 0)
		jQuery('#procore-project-template').append("<option value=''>N/A</option>");

	jQuery('#procore-project-template').prop('disabled', (procoreSettings.ProjectTemplates.length < 1));

	jQuery('#procore-project-type option').remove();
	if (procoreSettings.ProjectTypes.length > 0)
		jQuery('#procore-project-type').append("<option value=''>Select...</option>");
	for (i = 0; i < procoreSettings.ProjectTypes.length; i++) {
		jQuery('#procore-project-type').append("<option value='" + procoreSettings.ProjectTypes[i].id + "'>" + procoreSettings.ProjectTypes[i].name + "</option>");
	}

	if (procoreSettings.ProjectTypes.length == 0)
		jQuery('#procore-project-type').append("<option value=''>N/A</option>");

	jQuery('#procore-project-type').prop('disabled', (procoreSettings.ProjectTypes.length < 1));

	jQuery('#procore-project-stage option').remove();
	if (procoreSettings.ProjectStages.length > 0)
		jQuery('#procore-project-stage').append("<option value=''>Select...</option>");
	for (i = 0; i < procoreSettings.ProjectStages.length; i++) {
		jQuery('#procore-project-stage').append("<option value='" + procoreSettings.ProjectStages[i].id + "'>" + procoreSettings.ProjectStages[i].name + "</option>");
	}

	if (procoreSettings.ProjectStages.length == 0)
		jQuery('#procore-project-stage').append("<option value=''>N/A</option>");

	jQuery('#procore-project-stage').prop('disabled', (procoreSettings.ProjectStages.length < 1));

	if (procoreSettings.PublishExistingProjectCustomFieldId != 0) {
		jQuery('#procore-company-office').closest('tr').hide();
		jQuery('#procore-project-stage').closest('tr').hide();
		jQuery('#procore-project-type').closest('tr').hide();
		jQuery('#procore-project-template').closest('tr').hide();
		jQuery('#procore-project-program').closest('tr').hide();
		jQuery('#procore-project-name').closest('tr').hide();
		jQuery('#procore-est-start').closest('tr').hide();
		jQuery('#procore-est-complete').closest('tr').hide();
		jQuery('#procore-square-feet').closest('tr').hide();
		jQuery('#procore-project-number').closest('tr').hide();
	}

	dlgProcore = null; // just recreate it always.
	if (dlgProcore == null) {
		dlgProcore = jQuery('#procore-dialog').dialog({
			resizable: false,
			height: 505,
			width: 900,
			modal: true,
			title: "Procore Project Link",
			buttons: {
				"Publish to Procore": function () {
					jQuery('label.pjq-errortext', jQuery('#procore-project-name').parent()).remove();

					if (jQuery('#procore-project-name').val().toString().trim().length == 0) {
						jQuery('#procore-project-name').parent().append("<label for='procore-project-name' class='pjq-errortext'>Please enter a project name.</label>");
						jQuery('#procore-project-name').addClass('pjq-errortext');
						return;
					}

					var projectAddress = jQuery('#project-address1').val();
					if (jQuery('#project-address2').val().toString().trim()) {

						if (projectAddress)
							projectAddress += ' ';

						projectAddress += jQuery('#project-address2').val().toString().trim();
					}

					var stateProvince = jQuery('#project-state-us').val();
					if (!stateProvince)
						stateProvince = jQuery('#project-state-ca').val();

					var office_id = 0;
					if (jQuery('#procore-company-office').val())
						office_id = parseInt(jQuery('#procore-company-office').val());

					var project_stage_id = 0;
					if (jQuery('#procore-project-stage').val())
						project_stage_id = parseInt(jQuery('#procore-project-stage').val());

					var program_id = 0;
					if (jQuery('#procore-project-program').val())
						program_id = parseInt(jQuery('#procore-project-program').val());

					var project_type_id = 0;
					if (jQuery('#procore-project-type').val())
						project_type_id = parseInt(jQuery('#procore-project-type').val());

					var project_template_id = 0;
					if (jQuery('#procore-project-template').val())
						project_template_id = parseInt(jQuery('#procore-project-template').val());

					var square_feet = 0;
					if (jQuery('#procore-square-feet').val())
						square_feet = parseInt(jQuery('#procore-square-feet').val());

					ShowBusy('Connecting to Procore...');


					let postData = {
						company_id: parseInt(jQuery('#procore-company').val()),
						name: jQuery('#procore-project-name').val().toString().trim(),
						project_number: jQuery('#procore-project-number').val().toString().trim(),
						address: projectAddress,
						city: jQuery('#project-city').val().toString().trim(),
						zip: jQuery('#project-zip').val().toString().trim(),
						state_code: stateProvince,
						country_code: jQuery('#project-country').val(),
						description: '',
						public_notes: '',
						est_start_date: jQuery('#procore-est-start').val().toString().trim(),
						est_completion_date: jQuery('#procore-est-complete').val().toString().trim(),
						square_feet: square_feet,
						phone: '',
						flagColor: '',
						office_id: office_id,
						project_stage_id: project_stage_id,
						program_id: program_id,
						project_type_id: project_type_id,
						project_template_id: project_template_id,
						documentListPublic: GetProcoreCheckedPublicFolders(),
						documentListPrivate: GetProcoreCheckedPrivateFolders(),
						isSyncProjectContactVendors: jQuery('#procore-sync-vendors').is(':checked')
					};

					new PJQ.ajax.Request({
						endpoint: '/procore/projects',
						data: postData
					}).post().done(_.bind(function (data) {
						ProcoreCreateProjectC(data);
					}, this)).fail(_.bind(function (xhr, err, result) {
					}, this));
				}
			}
		});
	}
}

function ProcoreCreateProjectC(response) {
	HideBusy();
	jQuery('#procore-company').val('');
	var procoreProjectId = parseInt(response);
	if (procoreProjectId > 0) {
		jQuery('#procore').button('option', 'label', 'Published');
		//jQuery('#procore').button('option', 'disabled', true);
		project.ExternalProjectId = 'PROCORE:' + response;
		var url = settings.ProcoreURL + "/" + response + "/project/home";
		showInfoDialogPWall('Publish to Procore', 'Your project has been created in Procore.  Please allow time for any selected Folders to upload.<br /><br /><a href="' + url + '" target="_blank">Click here to open this project in Procore.', 'ui-icon-info');
	}
	else {
		showInfoDialogPWall('Publish to Procore', 'Project publish failed.', 'ui-icon-alert');
	}
	dlgProcore.dialog('close');
}

function GetProcoreCheckedPublicFolders() {
	var sharePublicFolders = new Array();
	if (tvPCPublic != null) {
		var checkedItemList = tvPCPublic.getAllChecked().split(',');
		var i = 0;
		for (i = 0; i < checkedItemList.length; i++) {
			if (!checkedItemList[i] || checkedItemList[i] == '')
				continue;

			if (tvPCPublic.isItemChecked(tvPCPublic.getParentId(checkedItemList[i])) == '1' && tvPCPublic.getParentId(checkedItemList[i]) != '1')
				continue;
			else
				sharePublicFolders.push(checkedItemList[i]);
		}
	}
	if (sharePublicFolders.length == 0) {
		sharePublicFolders.push('');
	}
	return sharePublicFolders.join(',');
}

function GetProcoreCheckedPrivateFolders() {
	var sharePrivateFolders = new Array();
	if (tvPCPrivate != null) {
		var checkedItemList = tvPCPrivate.getAllChecked().split(',');
		var i = 0;
		for (i = 0; i < checkedItemList.length; i++) {
			if (!checkedItemList[i] || checkedItemList[i] == '')
				continue;

			if (tvPCPrivate.isItemChecked(tvPCPrivate.getParentId(checkedItemList[i])) == '1' && tvPCPrivate.getParentId(checkedItemList[i]) != '2')
				continue;
			else
				sharePrivateFolders.push(checkedItemList[i]);
		}
	}
	if (sharePrivateFolders.length == 0) {
		sharePrivateFolders.push('');
	}
	return sharePrivateFolders.join(',');
}

function onProcoreError(response) {
	HideBusy();
	alert('Procore Error: ' + response.get_message() + ' - Stack Trace: ' + response.get_stackTrace());
}